// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"121":"c8967182","28023":"c8967182","29553":"c8967182","84690":"c8967182"}[chunkId] + ".chunk.css";
};